import { Card, Typography } from "antd";

const { Text } = Typography;

export default function QueueStrip({ upcoming }) {
  if (!upcoming.length) return null;

  return (
    <Card size="small">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 16,
          overflowX: "auto",
        }}>
        <Text
          type="secondary"
          style={{ letterSpacing: 1, whiteSpace: "nowrap" }}>
          PRÓXIMOS
        </Text>
        {upcoming.map((row, index) => (
          <div
            key={row.entry_id}
            style={{
              display: "flex",
              alignItems: "baseline",
              gap: 6,
              whiteSpace: "nowrap",
              fontWeight: index === 0 ? 600 : 400,
              opacity: index === 0 ? 1 : 0.7,
            }}>
            <span>{row.seller_name}</span>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {row.attendances}·{row.sales}
            </Text>
          </div>
        ))}
      </div>
    </Card>
  );
}
